// One short source label per card (the type is shown as an icon), e.g.
// "Databricks release notes (AWS)" → "AWS release notes".
import type { ContentType } from "../../shared/model.ts";

export function shortSource(sourceName: string, type: ContentType): string {
  const n = sourceName.toLowerCase();
  if (type === "release_note") {
    if (n.includes("azure")) return "Azure release notes";
    if (n.includes("google")) return "Google Cloud release notes";
    if (n.includes("aws")) return "AWS release notes";
    return "Release notes";
  }
  if (type === "announcement") return n.includes("newsroom") || n.includes("press") ? "Press release" : sourceName;
  return sourceName;
}
